import {
  Centred,
  Contents,
  RichText
} from '../../styles/mixins'

const styles = theme => ({
  centred: {
    ...Centred(theme),
  },
  contents: {
    ...Contents(theme),
  },
  text: {
  ...RichText(theme),
  
  },
  policyContents:{
    width:'100%',
    height:'100%',
    marginLeft: 'auto',
    marginRight: 'auto'

  },

  policyCentered:{
    width:'100%',
    height:'100%',
    display: 'flex',
    padding: '3rem 3rem 0 3rem',
    flexGrow: 1,
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'center'
  },
allpoliciescontent:{
  ...RichText(theme),
       
},

h1text:{
  fontSize:'2.1rem',
  fontWeight: 600,
  color: 'rgba(0,0,0,.7)',
  fontFamily: theme.typography.body1.fontFamily,
  marginTop: theme.spacing.unit * 5,
  marginBottom:theme.spacing.unit*5
},
link:{
  textDecoration:'none',

},

})

export default styles



// WEBPACK FOOTER //
// ./src/components/policy/styles.js